export default {
    data () {
        return {
            msg_tools_id: ''
        }
    },
    methods: {
        showMsgTools (id) {
            this.msg_tools_id = id
        },
        hideMsgTools () {
            this.msg_tools_id = ''
        }
    }
}